import { render, staticRenderFns } from "./depot2.vue?vue&type=template&id=497af0da&scoped=true&"
import script from "./depot2.vue?vue&type=script&lang=js&"
export * from "./depot2.vue?vue&type=script&lang=js&"
import style0 from "./depot2.vue?vue&type=style&index=0&id=497af0da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497af0da",
  null
  
)

export default component.exports